export default "__VITE_ASSET__bnxFVHKu__"